import { authCopy } from './copy';

/** Minimaal wat de API met `StrongPassword` eist; de API controleert de rest. */
export const MIN_PASSWORD_LENGTH = 12;

/** `undefined` als het adres er als een e-mailadres uitziet. */
export function validateEmail(value: string): string | undefined {
    const email = value.trim();

    if (email === '') {
        return authCopy.emailRequired;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        return authCopy.emailInvalid;
    }

    return undefined;
}

export interface NewPasswordErrors {
    password?: string;
    passwordConfirmation?: string;
}

/** Een nieuw wachtwoord, twee keer ingetypt. */
export function validateNewPassword(password: string, confirmation: string): NewPasswordErrors {
    const errors: NewPasswordErrors = {};

    if (password === '') {
        errors.password = authCopy.passwordRequired;
    } else if (password.length < MIN_PASSWORD_LENGTH) {
        errors.password = authCopy.passwordTooShort;
    }

    if (confirmation === '') {
        errors.passwordConfirmation = authCopy.confirmRequired;
    } else if (password !== confirmation) {
        errors.passwordConfirmation = authCopy.passwordMismatch;
    }

    return errors;
}
